import React, { Component } from 'react';
import Cookies from 'universal-cookie';
import { intersectionWith, isEqual } from 'lodash';

import getScrollPercent from '../../helpers/getScrollPercent';

import JoinPopup from './JoinPopup';
import NewsletterPopup from './NewsletterPopup';

import DataPopups from '../../data/popups.json';

class Popups extends Component {
  constructor(props) {
    super(props);

    this.state = {
      popup: null,
      isScrolled: false,
      wasVisible: false
    };
  }

  componentDidMount() {
    this.definePopup();
    
    window.addEventListener('scroll', this.handleScroll);
  }

  componentWillUnmount() {
    window.removeEventListener('scroll', this.handleScroll);
  }

  handleScroll = () => {
    if (getScrollPercent() >= 70) {
      this.setState({ isScrolled: true });
    }
  }

  ifCookies = (name) => {
    const cookies = new Cookies();
    return cookies.get(name) != 'true';
  }

  definePopup = () => {
    const tagsBlog = this.props.data?.blog?.frontmatter?.tags?.map((e) => e?.label?.toLowerCase());

    DataPopups.items.some((popup) => {
      let ifPage = popup.conditions?.pageSlug?.length > 0 ? typeof window !== 'undefined' && window.location.href.indexOf(popup.conditions.pageSlug) > -1 : true;
      let ifTags = popup.conditions?.tags?.length > 0 ? intersectionWith(tagsBlog, popup.conditions?.tags?.map((e) => e?.label?.toLowerCase()), isEqual).length > 0 : true;
      let ifConditions = ifPage && ifTags && this.ifCookies(popup.cookiesName);

      if (ifConditions) {
        this.setState({ popup: popup });
        return true
      }
      return false
    });
  }

  render() {
    const { popup } = this.state;
    let popupComponent = null;

    if (popup && this.state.isScrolled && !this.state.wasVisible) {
      if (popup?.typePopup === 'JoinPopup') {
        popupComponent = <JoinPopup
          title={popup.joinPopup?.title}
          items={popup.joinPopup?.items}
          image={popup.joinPopup?.image}
          imageClassName={popup.joinPopup?.imageClassName}
          idList={popup.joinPopup?.idList}
          cookiesName={popup.cookiesName}
          thanksText={popup.joinPopup?.thanksText}
          btnText={popup.joinPopup?.btnText}
          handleStateVisible={() => this.setState({ wasVisible: true })}
        />;
      } else if (popup?.typePopup === 'NewsletterPopup') {
        popupComponent = <NewsletterPopup
          cookiesName={popup.cookiesName}
          idList={popup.newsletterPopup?.idList}
          title={popup.newsletterPopup?.title}
          items={popup.newsletterPopup?.items}
          description={popup.newsletterPopup?.description}
          btnText={popup.newsletterPopup?.btnText}
          thanksText={popup.newsletterPopup?.thanksText}
        />;
      }
    }

    return popupComponent;
  }
}

export default Popups;